<template>
	<div class="tabs">
		<div class="tabs-nav" ref="tabsNav" @mousedown="startDrag" @mouseup="stopDrag" @mousemove="doDrag">
			<button
				class="button-tab"
				v-for="tab in tabs"
				:class="{ active: tab.isActive }"
				:key="tab.name"
				@click="selectTab(tab)"
			>
				{{ tab.name }}
			</button>
		</div>

		<div v-if="needMenu" class="tabs-nav controll">
			<button @mousedown="scrollLeft" @mouseup="stopMove()" class="button-tab">
				<i class="fas fa-arrow-left"></i>
			</button>
			<button @mousedown="scrollRight" @mouseup="stopMove()" class="button-tab">
				<i class="fas fa-arrow-right"></i>
			</button>
		</div>

		<div class="tabs-content">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			tabs: [],
			dragging: false,
			velocityDrag: 0.5,
			moving: false,
			interval: null,
			needMenu: false,
			sizeToShowMenu: 6,
			left: 0,
			top: 0,
			x: 0,
			y: 0
		};
	},

	mounted() {
		this.tabs = this.$children;
		this.needMenu = this.tabsNeedMenu();
	},

	methods: {
		selectTab(selectedTab) {
			if (!this.moving) {
				this.tabs.forEach(tab => {
					tab.isActive = tab._uid == selectedTab._uid;
				});
			}
		},

		startDrag(event) {
			this.dragging = true;
			this.x = event.clientX;
			this.y = event.clientY;
		},

		stopDrag(event) {
			this.dragging = false;
			this.moving = false;

			this.x = event.clientX;
			this.y = event.clientY;
		},

		doDrag(event) {
			let tabsNav = this.$refs.tabsNav;
			this.moving = true;
			if (this.dragging) {
				this.left = tabsNav.scrollLeft;
				let dx = event.clientX - this.x;
				tabsNav.scrollLeft -= dx * this.velocityDrag;
				this.teste = tabsNav.scrollLeft;
			}
		},

		scrollLeft() {
			this.interval = setInterval(() => {
				this.$refs.tabsNav.scrollLeft -= 10;
			}, 10);
		},

		scrollRight() {
			this.interval = setInterval(() => {
				this.$refs.tabsNav.scrollLeft += 10;
			}, 10);
		},

		stopMove() {
			clearInterval(this.interval);
		},

		tabsNeedMenu() {
			return this.tabs.length >= this.sizeToShowMenu;
		}
	}
};
</script>

<style lang="stylus" scoped></style>
